var _defs, _path, _path2, _path3, _path4, _path5, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\t\t\t.white { fill: white }\n\t\t\t#bar-top { animation: swing 0.75s cubic-bezier(.5,.0,.5,1) infinite; animation-delay: 0s; }\n\t\t\t#bar-middle { animation: swing 0.75s cubic-bezier(.5,.0,.5,1) infinite; animation-delay: 0.15s; }\n\t\t\t#bar-bottom { animation: swing 0.75s cubic-bezier(.5,.0,.5,1) infinite; animation-delay: 0.3s; }\n\t\t\t#hand { transform-origin: 50%; position: relative; animation:spin 3s linear infinite; }\n\t\t\t.st0{fill:none;}\n\t\t\t@keyframes spin { 100% { -webkit-transform: rotate(720deg); transform:rotate(720deg); } }\n\t\t\t@keyframes swing {\n\t\t\t\t0% { transform: translateX(-5%)  }\n\t\t\t\t50% { transform: translateX(+5%) }\n\t\t\t\t100% { transform: translateX(-5%) }\n\t\t\t}\n\t\t"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "clock") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "white",
    id: "bar-top",
    d: "M141.6,280.6H25.1c-3.4,0.1-6.1-2.4-6.3-5.8s2.4-6.1,5.8-6.3c0.1,0,0.4,0,0.5,0h116.6c3.4,0.1,5.9,3,5.8,6.3 C147.2,277.9,144.8,280.5,141.6,280.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "white",
    id: "bar-middle",
    d: "M123.4,242.3H6.8c-3.4,0.1-6.1-2.4-6.3-5.8c-0.1-3.4,2.4-6.1,5.8-6.3c0.1,0,0.4,0,0.5,0h116.6 c3.4,0.1,5.9,3,5.8,6.3C129,239.7,126.5,242.2,123.4,242.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "white",
    id: "bar-bottom",
    d: "M171.1,318.8H54.5c-3.4,0.1-6.1-2.4-6.3-5.8s2.4-6.1,5.8-6.3c0.1,0,0.4,0,0.5,0h116.6 c3.4,0.1,5.9,3,5.8,6.3C176.7,316.2,174.2,318.6,171.1,318.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M250.7,363.4c-19.3,0-38.4-5-55.3-14.3c-2.9-1.6-3.9-5.3-2.3-8.2c1.6-2.9,5.3-3.9,8.2-2.3c49.1,27.3,111,9.6,138.4-39.5 c27.3-49.1,9.6-111-39.5-138.4s-111-9.6-138.4,39.5c-0.3,0.5-0.6,1.1-0.9,1.6c-1.7,2.8-5.3,3.9-8.2,2.2c-2.7-1.6-3.8-5-2.4-7.9 c29.5-55.4,98.4-76.4,153.9-46.9s76.4,98.4,46.9,153.9C331.2,340.3,292.6,363.4,250.7,363.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M308.6,109.8H192c-3.4,0.1-6.1-2.4-6.3-5.8c-0.1-3.4,2.4-6.1,5.8-6.3c0.1,0,0.4,0,0.5,0h116.6c3.4,0.1,5.9,3,5.8,6.3 C314.2,107.2,311.7,109.7,308.6,109.8L308.6,109.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "hand",
    className: "white",
    d: "M250,227.6c-3.4,0-6-2.7-6-6v-48.4c-0.1-3.4,2.4-6.1,5.8-6.3c3.4-0.1,6.1,2.4,6.3,5.8c0,0.1,0,0.4,0,0.5v48.4 C256,224.9,253.4,227.6,250,227.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250,333.1c-3.4,0-6-2.7-6-6v-48.4c-0.1-3.4,2.4-6.1,5.8-6.3s6.1,2.4,6.3,5.8c0,0.1,0,0.4,0,0.5 V327C256,330.4,253.4,333.1,250,333.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "white",
    cx: 250,
    cy: 250,
    r: 6.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.d8b85422fdaf8086dcabff044b3e32d9.svg";
export { ForwardRef as ReactComponent };